<template>
  <div class="mt-[20px]">
    <a-alert class="alert" :show-icon="true" type="warning">
      <template #message>
        <span class="text-font-1">
          {{
            $t(
              'mei-ge-yong-hu-zui-duo-ke-guan-li-1-ge-ti-yan-ban-tuan-dui-zhang-hao-nin-dang-qian-yi-yong-you-accountslength-ge-zan-wu-fa-chuang-jian-xin-de-tuan-dui-nin-ke-yi-qie-huan-ti-yan-ban-zhang-hao-jin-hang-ti-yan-huo-zhe-sheng-ji-tuan-dui-jie-suo-geng-duo-quan-yi',
              [accounts.length],
            )
          }}
        </span>
      </template>
    </a-alert>
    <div class="mt-[20px] text-font-1 font-medium">
      {{ $t('nin-dang-qian-de-qi-ye-ti-yan-ban-bao-kuo') }}
    </div>
    <div>
      <div v-for="item in accounts" :key="item.user_id" class="account-list-item">
        <div class="flex items-center justify-between w-full mr-[100px]">
          <div
            class="flex items-center flex-1 truncate mr-[10px] cursor-pointer"
            @click="changeUserAndGoHome(item)"
          >
            <XUserAvatar :data="item" class="avatar"></XUserAvatar>
            <span class="flex-1 truncate text-font-80 flex items-center">
              <span> {{ item.org_name }}</span>
              <span class="text-font-50">({{ item.name || '-' }})</span>
              <XUserVerify
                :data="item"
                :status="item?.identify_info?.status"
                disabled
                class="scale-90 ml-[6px]"
              />
            </span>
          </div>
          <a @click="goLink(item)"> {{ $t('qu-sheng-ji') }} </a>
        </div>
      </div>
    </div>
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { getUserInfo, getUserToken, loginForWeb, setUserLog } from '~/api';
import type { LoginInfo } from '~/api/interface';
import { useCheckCreate } from '~/composables/user';
import { BROADCAST_KEY, COOKIE_KEY } from '~/constants/config';
import { PageKey } from '~/constants/page';
import { buriedLogin } from '~/utils/track';
const loading = ref(false);

defineProps<{ accounts: LoginInfo[] }>();

const router = useRouter();
const userInfo = useUserInfo();

const session = useSession();

function updateCustomSetting(userInfo: any) {
  CustomSettingApp.initAvatar(userInfo.logo_url, userInfo.default_logo_url);
  CustomSettingApp.initLogo(userInfo.platform_logo_url, userInfo.default_platform_logo_url);
}

async function goLink(loginInfo: LoginInfo) {
  await changeUser(loginInfo);
  // 关闭校验窗口
  const showCreateModal = useCheckCreate();
  showCreateModal.value = false;
  router.push({
    name: PageKey.SUBSCRIBE,
  });
}

async function changeUser(account: LoginInfo) {
  loading.value = true;

  if (!session.value?.user_id) {
    session.value = account;
    await setUserLog();
    const result = await getUserInfo();

    updateCustomSetting(result.data);
    userInfo.value = result.data;
    buriedLogin(Number(result.data?.user_id));
  } else {
    const token = await getUserToken(account.user_id);
    buriedLogin(Number(account.user_id));
    session.value = token?.data?.[0];
    // if (session.value) {
    //   loginForWeb(session.value)
    // }
    updateCustomSetting(token?.data?.[0]);
  }

  if (session.value) {
    // 如果依赖于下面的通知登录态，可能会出现外面页面以为登录成功触发刷新跳转，导致下面消息没有发出，最终导致登录态没有植入的问题
    await loginForWeb(session.value);
  }

  // emitBroadcast(COOKIE_KEY.USER_TOKEN, {
  //   cookieValue: JSON.parse(JSON.stringify(session.value)),
  // })
  emitBroadcast(BROADCAST_KEY.REFRESH, { tabId: TAB_ID });

  loading.value = false;
}

async function changeUserAndGoHome(loginInfo: LoginInfo) {
  await changeUser(loginInfo);

  goHome();
}
</script>
<style lang="scss">
.alert.ant-alert {
  display: flex;
  align-items: flex-start;
}

.alert .anticon {
  margin-top: 4px;
}
</style>
<style lang="scss" scoped>
.avatar {
  width: 34px;
  height: 34px;
}

.account-list-item {
  @apply rounded-[8px];
  padding-left: 16px;
  padding-right: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 4px;
  width: calc(100% - 8px);
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  height: 44px;
  line-height: 44px;

  &.account-list-item-selected {
    background-color: var(--back-2);
    color: var(--purple-6);
  }

  &:hover {
    background: var(--back-2);
  }
}
</style>
